import { ChangeDetectionStrategy, Component, effect, input, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule, ValidatorFn } from '@angular/forms';
import { TextInputComponent } from '../../inputs/text-input/text-input.component';
import { FormErrorComponent } from '../../form-error/form-error.component';
import { v4 as uuidv4 } from 'uuid';
import { htmlMaxCharacterValidator } from '../../../../validators/html-max-characterl.validator';
import { startWith } from 'rxjs';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'lib-text-form-field',
  imports: [ReactiveFormsModule, TextInputComponent, FormErrorComponent, DecimalPipe],
  templateUrl: './text-form-field.component.html',
  styleUrl: './text-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextFormFieldComponent {
  inputFormControl = input.required<FormControl>();
  label = input.required<string>();
  isSubmitted = input<boolean>(false);
  placeholder = input<string | null | undefined>();
  hintText = input<string | null | undefined>();
  autocomplete = input<string>('on');
  maxCharacters = input<number | null>(null);
  inputMode = input<'text' | 'numeric' | 'decimal' | 'tel' | 'search' | 'email' | 'url'>('text');
  helpText = input<string>();

  protected charCount = signal<number>(0);

  inputId: string = uuidv4();
  private maxCharacterValidator: ValidatorFn | null = null;

  formControlEffect = effect(() => {
    this.inputFormControl()
      .valueChanges.pipe(startWith(this.inputFormControl().value))
      .subscribe(value => this.charCount.set(value?.length ?? 0));
  });

  characterCountEffect = effect(() => {
    const maxCharacters = this.maxCharacters();
    if (maxCharacters !== null) {
      this.maxCharacterValidator = htmlMaxCharacterValidator(maxCharacters);
      this.inputFormControl().addValidators(this.maxCharacterValidator);
    } else if (this.maxCharacterValidator) {
      this.inputFormControl().removeValidators(this.maxCharacterValidator);
    }
  });
}
